import { PORT_STATE } from "../script/common";
export function formatRecValToDispForm(val) {
    return val.toFixed(4).padStart(7);
}
export function handleMsg(msg) {
    if (msg.length < 3)
        return; // TODO
    const msgData = msg.slice(0, -2);
    const valRegex = /(\d),(.*?),"CEL"/i;
    const valRegexRes = valRegex.exec(msgData);
    const infoRegex = /WIKA,(.*?),(.*?),(.*?),(.*?)\/(.*?)\/(.*?)$/i;
    const infoRegexRes = infoRegex.exec(msgData);
    const errRegex = /'ERR CMD$/i;
    const errRegexRes = errRegex.exec(msgData);
    if (valRegexRes) {
        // console.log("parsed", valRegexRes[2]);
        return {
            port: valRegexRes[1],
            portParsed: parseInt(valRegexRes[1]),
            val: parseFloat(valRegexRes[2])
        };
    }
    else if (infoRegexRes) {
        console.log("Device info", msgData);
    }
    else if (errRegexRes) {
        console.log("Device ERROR", msg);
    }
    else {
        console.warn("Unknown msg type", msg);
    }
}
function genKeyCountLock() {
    let map = {};
    return {
        inc: (key, val) => {
            if (!(key in map) || map[key].count === 0) {
                map[key] = {
                    count: 1,
                    value: val,
                };
                return true;
            }
            return false;
        },
        dec: (key) => {
            if (!(key in map)) {
                return [false, null];
            }
            map[key].count -= map[key].count === 0 ? 0 : 1;
            if (map[key].count === 0) {
                return [true, map[key].value];
            }
            return [false, null];
        }
    };
}
const globalWikaLock = genKeyCountLock();
export class WikaParser {
    constructor(usedPort, onNewVal) {
        this.usedPort = usedPort;
        this.onNewVal = onNewVal;
        this.DEFAULT_INTERVAL = 2000;
        this.buf = [];
        this.lastVal = {
            port: '',
            portParsed: NaN,
            val: NaN
        };
        this.usedWikaPorts = [];
        this.readSubs = usedPort.readerObs.subscribe((binData) => {
            if (!binData)
                return;
            this.newPart(binData);
            const val = this.getLastValue();
            if (!isNaN(val.val) && this.usedWikaPorts.includes(val.port)) {
                this.onNewVal(val);
            }
        }); // bad design, TODO
    }
    setLastValue(lv) {
        this.lastVal = lv;
    }
    getLastValue() {
        return this.lastVal;
    }
    startRequestTimer(wikaReadPort, interval) {
        this.stopRequestTimer();
        if (!interval) {
            interval = this.DEFAULT_INTERVAL;
        }
        this.usedWikaPorts = wikaReadPort;
        wikaReadPort.forEach(wp => {
            let intervaId = null;
            const destructor = () => {
                if (intervaId) {
                    clearInterval(intervaId);
                }
            };
            const init = () => {
                const send = () => {
                    const ENC = new TextEncoder();
                    // console.log('SEND', wp, wikaReadPort, this);
                    if (this.usedPort.meta.state.text === PORT_STATE.CONNECTED_ACT.text) {
                        this.usedPort.writerObs.send(ENC.encode(`measure:channel? ${wp}\r\n`));
                    }
                };
                // send();
                intervaId = setInterval(send, interval);
            };
            const first = globalWikaLock.inc(wp, destructor);
            if (first) {
                init();
            }
        });
    }
    stopRequestTimer() {
        this.usedWikaPorts.forEach(key => {
            const [last, destructor] = globalWikaLock.dec(key);
            if (last) {
                destructor();
            }
        });
        this.usedWikaPorts = [];
    }
    newPart(bin) {
        const DEC = new TextDecoder();
        const str = DEC.decode(bin);
        const strArr = str.split("");
        strArr
            .filter((val) => Boolean(val))
            .forEach((val) => {
            this.buf.push(val);
            if (val === "\n") {
                const msg = handleMsg(this.buf.join(""));
                this.buf = [];
                this.setLastValue(msg);
            }
        });
    }
    clear() {
        console.log('WIKA clear');
        this.stopRequestTimer();
        if (this.readSubs)
            this.readSubs();
    }
}
